import Vue from 'vue'
import snackbar from '@/utils/snackbar'

const defaultMessage = 'Sorry. Something went wrong.'

Vue.config.errorHandler = error => handleError(error)

// Errors in async functions are a problem
window.onunhandledrejection = function (event) {
  if (event.reason) {
    handleError(event.reason)
  } else {
    snackbar.show(defaultMessage, 'error')
    console.error(event)
  }
}

function handleError (error) {
  const getMessage = function (error) {
    if (error.response) {
      const data = error.response.data
      if (data.error && data.error.message) {
        return data.error.message
      }
      if (data.message) {
        return data.message
      }
    }
    return defaultMessage
  }

  const message = getMessage(error)
  snackbar.show(message, 'error')

  // Log geekMessage if found
  if (error.response && error.response.data.error) {
    // console.log('error', [error.response.data.error])
    Vue.$log &&
            Vue.$log.error(
              error.response.data.error.geekMessage,
              error.response.data.error.errorData
            )
  } else {
    // Log the error in non-production
    // if (error !== null) { console.log(error) }
    if (process.env.NODE_ENV !== 'production') {
      if (error !== null) { console.log(error) }
    }
  }
}
